import { useQuery } from 'react-query';
import * as api from '../../services/api';

const useGenericIntegrations = () => {
  const storeKey = ['genericIntegrations'];
  const { isLoading, data } = useQuery(storeKey, api.fetchGenericIntegrations);

  return { isLoading, integrations: data?.data || [] };
};

export default useGenericIntegrations;
